<template>
  <div class="section-new-order section-full">
    <form-staff :title="$gettext('Add Staff')"/>
  </div>
</template>

<script>
import FormStaff from '@/components/FormStaff.vue';
import { mapState } from 'vuex';
export default {
  name: 'AddStaff',
  components: {
    FormStaff,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  created() {
    if(this.user.location.useLocalServer) {
      this.$router.push('order')
    }
  }
};
</script>
